<template>
  <div>
    <strong style="font-size: 150%">Fecha Entrega</strong>

    <b-row class="mt-5 mb-3">
      <b-col cols="3">
        <label for="nuevaFechaEntrega" class="form-label">Nueva Fecha Entrega</label>
        <b-form-datepicker
          style="font-size: 90%; background:rgb(228, 245, 229);"
          v-model="nuevaFechaEntrega"
          id="nuevaFechaEntrega"
          resetButton
          placeholder="Seleccionar fecha"
          label-help=""
        ></b-form-datepicker>
      </b-col>
      <b-col cols="8">
        <label for="nuevoComentarioEntrega" class="form-label">Comentario / Motivo</label>
        <b-form-input
          style="font-size: 90%;background:rgb(228, 245, 229);"
          v-model="nuevoComentarioEntrega"
          id="nuevoComentarioEntrega"
          placeholder="Escriba un comentario..."
        ></b-form-input>
      </b-col>

      <b-col cols="1" style="padding: 29px 0px 0px 0px">
        <b-button
          variant="success"
          class="actionButton"
          @click="addHitoEntrega"
          :disabled="!nuevaFechaEntrega || !nuevoComentarioEntrega"
        >
          +
        </b-button>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <b-table
          style="font-size: 90%"
          class="shadow-sm vertical-center mt-4 text-center"
          responsive
          sticky-header="190px"
          id="hitosEntregaTable"
          :fields="$constants().hitoEntregaTableFields"
          :items="hitoEntregas"
          bordered
          hover
          small
        >
          <template #cell(fechaCreacion)="data">
             {{ data.item.fechaCreacion ? data.item.fechaCreacion : '' }}
          </template>
          
          <template #cell(action)="row" text-center>
            <b-button-group text-center size="sm">
              <b-button
                :disabled="!['ROLE_SUPERADMIN','ROLE_MANAGER'].includes(currentUser.roles[0])"
                size="sm"
                class="actionButton"
                variant="outline-danger"
                @click="deleteHitoEntrega(row.index)"
              ><i class="fas fa-trash-alt"></i></b-button>
            </b-button-group>
          </template>
        </b-table>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "HitosEntregaItem",
  data() {
    return {
      hitoEntregas: [],
      nuevaFechaEntrega: "",
      nuevoComentarioEntrega: ""
    }
  },
  methods: {
    addHitoEntrega() {
      if (!this.nuevaFechaEntrega || !this.nuevoComentarioEntrega) {
        return;
      }
      
      const newHito = {
        fechaCreacion: new Date().toISOString().split('T')[0],
        fechaEntrega: this.nuevaFechaEntrega,
        comentario: this.nuevoComentarioEntrega
      };
      
      this.hitoEntregas.push(newHito);
      
      this.nuevaFechaEntrega = "";
      this.nuevoComentarioEntrega = "";
    },
    deleteHitoEntrega(index) {
      this.hitoEntregas.splice(index, 1);
    }
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    }
  }
};
</script>

<style scoped>
.actionButton {
  padding: 0.375rem 0.75rem;
}
</style>
